export default {
  routeNotFound: 'Uložená URL adresa sa nenašla',
};
